export default __webpack_public_path__ + "Credit-Card.ec33274dfdab608d3f13.png";